import gql from 'graphql-tag'
import apolloClient from '../../utils/graphqlClient'
import * as types from '../../utils/actionTypes'
import { getInvolvedNodes } from './selectors'

// TOGGLE PLOT
const togglePlotSelection = plotBoolean => ({
  type: types.TOGGLE_PLOT_SELECTION,
  payload: plotBoolean,
})

export const togglePlot = plotBoolean => dispatch =>
  dispatch(togglePlotSelection(plotBoolean))

// SET BUDGET
const setBudgetSelection = budgetValue => ({
  type: types.SET_BUDGET_SELECTION,
  payload: budgetValue,
})

export const setBudget = budgetValue => dispatch =>
  dispatch(setBudgetSelection(budgetValue))

// TOGGLE NODES
const toggleNodesSelection = nodes => ({
  type: types.TOGGLE_NODES_SELECTION,
  payload: nodes,
})

export const toggleNodes = node => (dispatch, getState) => {
  const nodes = getInvolvedNodes({
    state: getState(),
    node,
  })
  return dispatch(toggleNodesSelection(nodes))
}

// SET OFFER FORM
const createOfferMutation = gql`
  mutation createOffer($offer: NewOffer!) {
    createOffer(offer: $offer) {
      id
    }
  }
`
const setClientSelection = form => ({
  type: types.SET_CLIENT_SELECTION,
  payload: form,
})

export const setClient = form => async (dispatch, getState) => {
  dispatch(setClientSelection(form))
  try {
    const state = getState()
    if ('selection' in state) {
      const mutationResult = await apolloClient.mutate({
        variables: { offer: state.selection },
        mutation: createOfferMutation,
      })
      dispatch(
        setClientSelection({
          ...state.selection.client,
          offerId: mutationResult.data.createOffer.id,
        }),
      )
    }
    return true
  } catch (error) {
    console.error(error)
    return false
  }
}



// WEBPACK FOOTER //
// ./src/modules/selection/actions.js